import classNames from "classnames";
import type * as React from "react";

import style from "./Spinner.module.css";

export type SpinnerProps = {
  color?: string;
  stickCount?: number;
  className?: string;
  size?: number | "sm" | "lg";
};

export const Spinner: React.FC<SpinnerProps> = (props) => {
  const color = props.color ?? "#999";
  const sticks = props.stickCount ?? 8;
  const classname = props.className;

  let size = 53;
  if (typeof props.size === "number") {
    size = props.size;
  } else if (props.size === "sm") {
    size = 42;
  } else if (props.size === "lg") {
    size = 79;
  }

  return (
    <div
      className={classNames(style.loader, classname)}
      role="progressbar"
      style={{ "--color": color, "--sticks": sticks, "--size": `${size}px` } as React.CSSProperties}
    >
      {[...new Array(sticks)].map((_, i) => (
        <div
          key={i}
          style={
            {
              "--rotation": `${(i * 360) / sticks}deg`,
              "--opacity": (i + 1) * (1 / (sticks + 1)),
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
};
